import { useEffect, useState } from 'react';

// 1440 px is Leo's design. Below it: laptop (900-1279), tablet (768-899), phone (under 768).
export const viewportKind = (w) => (w >= 1280 ? 'wide' : w >= 900 ? 'laptop' : w >= 768 ? 'tablet' : 'phone');

export function useViewportKind() {
  const [kind, setKind] = useState(() => viewportKind(typeof window === 'undefined' ? 1440 : window.innerWidth));
  useEffect(() => {
    const on = () => setKind(viewportKind(window.innerWidth));
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return kind;
}
